import React, { Component } from 'react'
import { connect } from 'react-redux'
import VaultResGetExpiringSample from '../samples/VaultResGetExpiringSample'

import { makeVaultResGetExpiring } from '../../../actions/vaultAction'
import { updateOrderId } from '../../../actions/commonActions'
import { _VAULT } from '../../../actions/types'

export class VaultGetExpiring extends Component {
    state = {
        showError:false,
        showSuccess:false,
        justClicked:false,
      };
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    renderMessage() {
        if(!this.state.showError && !this.state.showSuccess && this.state.justClicked){
            return (
                <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#F5DEB3', color:'#FF9912', padding:'1vw', borderRadius:'10px', border:'1px solid #F5DEB3', lineHeight: '3vh'}}>
                    <strong>Note:</strong><br />
                    ResGetExpiring may take longer than others
                </div>
            );
        }
        if(this.state.showError) {
            return (
                <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#ffcccc', color:'#cc0000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}>
                    <strong>Error!</strong><br />
                    Please check your parameters within Vault ResGetExpiring.
                </div>
            );
        }
        // else if(this.state.showSuccess) {
        //     return (
        //         <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#d6f5d6', color:'#196719', padding:'1vw', borderRadius:'10px', border:'1px solid #6fdc6f', lineHeight: '3vh'}}>
        //             <strong>Vault ResGetExpiring Accepted!</strong><br />
        //             The returned receipt has been inserted to the JSON on the right, you can make another Vault Request now.
        //         </div>
        //     );
        // }
    }

    //TODO fix this
    componentDidUpdate() {
        const { resgetexpiringSuccess,ResGetExpiringResponse,loading } = this.props; 
        if(ResGetExpiringResponse!=="No request has been made."  && this.state.justClicked){
            if(resgetexpiringSuccess){
                    this.setState({ showError: false,showSuccess: true,justClicked:false });  
                }
            else {
                if(!loading){
                    this.setState({  showError: true, showSuccess: false,justClicked:false });
                }
            }
        }
    }
    async onMakeExpiringPress() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _VAULT, orderId: newOrderId });
        const { storeId, apiToken, order_id, pan, expdate, amount } = this.props;
        const expiringRequest = { storeId, apiToken, order_id, pan, expdate, amount };
        this.props.makeVaultResGetExpiring(expiringRequest);
        this.setState({justClicked:true});
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample ResGetExpiring</h3>
                <VaultResGetExpiringSample/>
                <div className="requestButton" onClick={() => this.onMakeExpiringPress()}>
                    ResGetExpiring Request
                </div> 
                {this.renderMessage()}
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
    renderDocument() { 
        const { progLangId } = this.props;
        return (
            <div className="stepPageContainer">
            <h3 className="stepPageTitle">Vault Get Expiring – ResGetExpiring</h3>

            <p><b>Vault Get Expiring transaction object definition</b></p> 
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>ResGetExpiring resGetExpiring = new ResGetExpiring();
                            </code>
                        case 1:
                            return <code>ResGetExpiring resGetExpiring = new ResGetExpiring();
                            </code>
                        case 2:
                            return <code>
                                {`$txnArray = array(‘type’=>’res_get_expiring', …);`}<br/>
                                {`$mpgTxn = new mpgTransaction($txnArray);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
            <p><b>HttpsPostRequest object for Vault Get Expiring transaction</b></p> 
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();
                            </code>
                        case 1:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();

                            </code>
                        case 2:
                            return <code>
                                {`$mpgRequest = new mpgRequest($mpgTxn);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
                   {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>mpgReq.SetTransaction(resGetExpiring);</code>
                        case 1:
                            return <code>mpgReq.SetTransaction(resGetExpiring);</code>
                        case 2:
                            return <code>
                                {`$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);`}
                                </code>
                        default:
                            return null
                        }
                    })()}
        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault Get Expiring transaction request fields – Required</h3>
            <p>This transaction has no required request fields.</p>
            <p><b>Vault response fields</b></p>
            <p>For a list and explanation of (Receipt object) response fields that are available after sending this Vault
                transaction, see Definitions of Response Fields.
            </p>
        </div>
        )
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { resgetexpiringSuccess,ResGetExpiringResponse,loading } = state.vault.main;
    const { storeId, apiToken, order_id, pan, expdate, amount} = state.vault.main.config;
    return { mode, storeId, apiToken, order_id, pan, expdate, amount,loading, progLangId: state.common.progLangList.selection,resgetexpiringSuccess,ResGetExpiringResponse };
  }

export default connect(mapStateToProps,{updateOrderId,makeVaultResGetExpiring})(VaultGetExpiring) 